export default "/_next/static/images/b7a78710076f6485bde9196374437838.png";